import React, { useState } from "react";
import { motion } from "framer-motion";
import { fadeUp } from "../../animations/variants";
import { Phone, Mail, MapPin, PhoneCall } from "lucide-react";
import { useSelector } from "react-redux";
import { useNavigate, useSearchParams } from "react-router-dom";
import { contactFormText } from "i18n/contactCTA";
import CTAButton from "Util/CTAButton";

const PriceSection = () => {
  const { sourceSlug, sourceTitle } = useSelector((state) => state.contact);

  const [searchParams] = useSearchParams();

  const workshopSlug = searchParams.get("workshop");
  const workshopTitle = searchParams.get("title");

  const lang = useSelector((state) => state.language.lang);
  const t = contactFormText[lang];
  const [showForm, setShowForm] = useState(false);

  const navigate = useNavigate();
  // Prefer URL → fallback Redux
  const finalTitle = workshopSlug
    ? workshopTitle || workshopSlug.replaceAll("-", " ")
    : "";

  return (
    <section className="relative overflow-hidden py-20 lg:py-28 bg-[#0d0d0d]">
      <div className="absolute inset-0 overflow-hidden">
        <div className="absolute top-0 left-1/4 w-96 h-96 bg-reddark/10 rounded-full blur-[120px]" />
        <div className="absolute bottom-0 right-1/4 w-96 h-96 bg-red-500/10 rounded-full blur-[120px]" />
      </div>
      <div className="max-w-7xl mx-auto px-6 ">
        <motion.div
          variants={fadeUp}
          initial="hidden"
          whileInView="show"
          viewport={{ once: true }}
          className="
        relative
        rounded-[32px]
        border-0 lg:border border-white/10
        bg-none lg:bg-white/[0.03]
        backdrop-blur-xl
        p-0 py-10 lg:p-10 md:p-16
        text-center
        overflow-hidden
      "
        >
          <div className="hidden lg:flex absolute top-0 left-0 w-full h-1 bg-gradient-to-r from-reddark via-red-500 to-reddark" />

          <motion.div
            id="contact-form"
            initial={{ opacity: 0, y: 40 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.5 }}
            className=""
          >
            {" "}
            <motion.div
              variants={fadeUp}
              initial="hidden"
              whileInView="show"
              viewport={{ once: true }}
              className="flex items-center justify-center gap-4 mb-6"
            >
              <span className="w-12 h-px bg-reddark" />
              <span className="uppercase tracking-[0.3em] text-sm text-white/80 font-medium">
                {t.sessionTitle}
              </span>
              <span className="w-12 h-px bg-reddark" />
            </motion.div>
            <motion.div
              variants={fadeUp}
              initial="hidden"
              whileInView="show"
              viewport={{ once: true }}
              className="w-24 h-1 bg-reddark rounded-full mb-8 mx-auto"
            />
            <div className="space-y-5">
              {t.sessions.map((session, index) => (
                <motion.div
                  key={index}
                  whileHover={{ y: -4 }}
                  className="
                      group relative overflow-hidden
                      rounded-[2rem]
                      border border-white/10
             backdrop-blur-xl
                      p-6 md:p-8
                      shadow-[0_10px_40px_rgba(0,0,0,0.05)]
                      transition-all duration-500
                    "
                >
                  <div className="absolute top-0 right-0 w-32 h-32 bg-reddark/5 blur-3xl rounded-full" />

                  <div className="relative z-10 flex flex-col lg:flex-row lg:items-center lg:justify-between gap-6 ">
                    <div className="flex flex-col items-start justify-start">
                      <div className="flex items-center gap-3 mb-3">
                        <div className="w-3 h-3 rounded-full bg-reddark" />

                        <span className="text-sm uppercase tracking-[0.2em] text-gray-500">
                          Session {index + 1}
                        </span>
                      </div>

                      <h5 className="text-2xl md:text-3xl font-[Crimson] text-white leading-tight mb-3 text-left uppercase">
                        {session.title}
                      </h5>

                      <p className="text-gray-400 text-base">
                        {session.duration}
                      </p>
                    </div>

                    <CTAButton
                      variant="primary"
                      icon={PhoneCall}
                      text={session.button}
                      onClick={() => {
                        // paypal booking
                        if (session.link.startsWith("http")) {
                          window.open(session.link, "_blank");
                          return;
                        }

                        if (session.link === "email") {
                          window.location.href =
                            "mailto:info@mariaadvisory.com";
                          return;
                        }
                      }}
                    />
                  </div>
                </motion.div>
              ))}
            </div>
          </motion.div>
        </motion.div>
      </div>
    </section>
  );
};

export default PriceSection;
